import React from 'react';
import styles from './LoginForm.module.css';
import { Link } from 'react-router-dom';
import LoginLeftSide from '../../components/LoginLeftSide/LoginLeftSide';
import keycloak from '../../keycloak';
import ContactButton from '../../components/ContactButton/ContactButton';


const LoginForm = () => {
  const dashboardRedirectUri = typeof window !== "undefined" ? `${window.location.origin}/` : undefined;

  const handleLogin = () => {
    keycloak.login({ redirectUri: dashboardRedirectUri });
  };

  const handleLogout = () => {
    keycloak.logout({ redirectUri: dashboardRedirectUri });
  };

  return (
    <div className={styles.loginContainer}>
      <LoginLeftSide />

      <div className={styles.rightSide}>
        <div className={styles.rightContent}>
          <ContactButton />
        </div>

        <div className={styles.formcontainer}>
          <div className={styles.login}>
            <div className={styles.title}>Log in to your account</div>

            <div>
              <div className={styles.buttonContainer}>
                <button 
                  type="button" 
                  onClick={handleLogin}
                  className={styles.loginButton}
                >
                  LOGIN WITH KEYCLOAK
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.bottomContent}>
          <ContactButton />
        </div>

      </div>
    </div>
  );
};

export default LoginForm;
